export default (w, d) => {
  let t;

  const hideLayout = ($layout) => {
    clearInterval(t);
    $layout.style.display = 'none';
  };

  const countDownTimer = () => {
    const _second = 1000;
    const _minute = _second * 60;
    const _hour = _minute * 60;
    const _day = _hour * 24;
    const $defaultProduct = document.querySelector('#main') || {};
    const { hasProducts } = $defaultProduct.dataset || {};

    [...d.querySelectorAll('.fc-layout-903'), ...d.querySelectorAll('.fc-layout-904')].forEach(($layout) => {
      const [$targetTime] = $layout.getElementsByClassName('fc-timer-target-time');

      if (($defaultProduct && hasProducts === 'true' && $targetTime) || ($defaultProduct && $targetTime)) {
        const targetTime = $targetTime.textContent;
        const now = new Date();
        const end = new Date(targetTime);
        const distance = end - now;

        if (distance < 0) {
          hideLayout($layout);
          return;
        }

        $layout.querySelector('.fc-timer-days .fc-time-txt').innerText = Math.floor(distance / _day);
        $layout.querySelector('.fc-timer-hours .fc-time-txt').innerText = Math.floor((distance % _day) / _hour);
        $layout.querySelector('.fc-timer-minutes .fc-time-txt').innerText = Math.floor((distance % _hour) / _minute);
        $layout.querySelector('.fc-timer-seconds .fc-time-txt').innerText = Math.floor((distance % _minute) / _second);

        clearInterval(t);
        t = setInterval(countDownTimer, _second);
      } else {
        $layout.style.display = 'none';
      }
    });
  };

  countDownTimer();
};
